import Vue from "vue";
import Vuex from "vuex";
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";
import requestCache from "./modules/requestCache";
Vue.use(Vuex);

// GET_CART_INFO 进行中的请求引用: 并发 dispatch 时合并为一次网络请求
let cartInfoInflight = null;

export default new Vuex.Store({
  modules: {
    requestCache,
  },
  state: {
    pageLeftImg: localStorage.getItem("pageLeftImg"),
    navList: [],
    isLogin: utils.isLogin(),
    userInfo: JSON.parse(localStorage.getItem("userInfo")) || {},
    mobAccountList: [
      {
        label: '尊敬的顾客',
        pathName: 'Account',
        key: ''
      },
      {
        label: '购物车',
        pathName: 'Cart',
        key: ''
      },
      {
        label: '我的订单',
        pathName: 'Orders',
        key: ''
      },
      {
        label: '客服中心',
        pathName: 'udesk-go-service',
        key: 'help'
      },
      {
        label: '店铺导航',
        pathName: 'Store-finder',
        key: ''
      },
    ],
    cartInfo: { list: [], },
    addressList: [], // 地址簿列表（Cart 预取，Checkout 等页面复用）
    //OWHS-9910 - 【OT】网站和小程序前端请求header传上级页面URL
    historyListMax: 10,
    //从前往后插入元素
    historyList: [],
    //OWHS-10117 - 【OT】管小下单时最高抵扣积分由20% 改为30%
    //获取oss json全局配置
    commonConfig: {},
    tagsConfig: {}, // 标签管理
    isShowCustomerTag: false, // 是否展示标签
    cookieAccept: null,
    privacyAccept: null,
    showCookieDialog: false // 添加控制弹框显示的状态
  },
  mutations: {
    saveNavList(state, payload) {
      state.navList = payload.list;
      state.pageLeftImg = payload.register_left_pic;
      localStorage.setItem("pageLeftImg", state.pageLeftImg);
    },
    SET_IS_SHOW_CUSTOMER_TAG(state, value) {
      state.isShowCustomerTag = value;
      Vue.cookie.set("newCustomerState", value);
    },
    [types.LOGIN](state, payload) {
      utils.setToken(payload);
      state.isLogin = true;
    },
    [types.LOGOUT](state, payload) {
      utils.removeToken();
      localStorage.removeItem("userInfo");
      Vue.cookie.delete("userInfo");
      state.isLogin = false;
      state.userInfo = null;
      typeof payload == "function" && payload();
    },
    [types.GET_PROFILE](state, payload) {
      localStorage.setItem("userInfo", JSON.stringify(payload));
      state.userInfo = payload;
      if (payload.username) {
        state.mobAccountList[0].label = payload.username;
      }
      //nuxt不能用local存储 用cookie再存一遍
      // eslint-disable-next-line no-unused-vars
      const { crm, ...restPayload } = payload || {};
      Vue.cookie.set("userInfo", JSON.stringify(restPayload));
    },
    [types.GET_CART_INFO](state, payload) {
      // 过滤失效商品（下架/无库存），仅保留正常商品
      state.cartInfo = {
        ...payload,
        list: (payload?.list || []).filter((item) => utils.getCartItemStatus(item) === "Normal"),
      };
    },
    [types.PUSH_HISTORY](state, payload) {
      // 如果队列已满，先移除最后一个元素
      if (state.historyList.length >= state.historyListMax) {
        state.historyList.pop();
      }
      // 然后在队列的最前面添加新元素
      state.historyList.unshift(payload);
    },
    [types.SET_COOKIE_ACCEPT](state, cookieAccept) {
      state.cookieAccept = cookieAccept;
    },
    [types.SET_PRIVACY_ACCEPT](state, privacyAccept) {
      state.privacyAccept = privacyAccept;
    },
    [types.SHOW_COOKIE_DIALOG](state, payload) {
      state.showCookieDialog = payload;
    },
    // 地址簿列表
    SET_ADDRESS_LIST(state, payload) {
      state.addressList = payload || [];
    }
  },
  actions: {
    setIsShowCustomerTag({ commit }, value) {
      commit('SET_IS_SHOW_CUSTOMER_TAG', value);
    },
    [types.LOGOUT]({ commit }, payload) {
      api[types.LOGOUT]()
        .then(() => {
          commit(types.LOGOUT, payload);
        })
        .catch((err) => {
          console.warn(err);
          // logout 接口失败也本地清 token（mutation 幂等），避免退出后 isLogin() 仍为 true
          commit(types.LOGOUT, payload);
        });
    },
    [types.GET_PROFILE]({ commit }) {
      api[types.GET_PROFILE]()
        .then((res) => {
          commit(types.GET_PROFILE, res.data);
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // 获取地址簿列表
    [types.ADDRESS_LIST]({ commit }) {
      return api[types.ADDRESS_LIST]()
        .then((res) => {
          if (res?.code == 1) {
            commit("SET_ADDRESS_LIST", res?.data?.list || []);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    [types.GET_CART_INFO]({ commit }) {
      // 登录 → 用户购物袋；未登录 → 游客购物袋
      // 用 utils.isLogin() 实时读 token，比 state.isLogin 快照更可靠
      const apiType = utils.isLogin() ? types.GET_CUSTOMER_CART : types.GET_CART;
      // 请求进行中时后续 dispatch 复用同一 promise, 避免重复请求(如 Header 角标与 Cart 页同时拉取)
      if (cartInfoInflight) {
        return cartInfoInflight;
      }
      cartInfoInflight = api[apiType]()
        .then((res) => {
          if (res?.code == 1) {
            let _cart = res?.data?.list
              ? res.data
              : {
                  list: [],
                  shipping: "0.00",
                  subTotal: "0.01",
                  amount: "0.01",
                };
            commit(types.GET_CART_INFO, _cart);
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        })
        .finally(() => {
          cartInfoInflight = null; // 请求结束(无论成败)后清除, 后续 dispatch 正常重新发起
        });
      return cartInfoInflight;
    },
    // 获取购物袋-用户
    [types.GET_CUSTOMER_CART]({  commit }) {
      api[types.GET_CUSTOMER_CART]()
        .then((res) => {
          if (res?.code == 1) {
            commit(types.GET_CART_INFO, res.data || { list: [] });
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // 购物袋修改选择-用户
    [types.CHANGE_CHOOSE_OF_CUSTOMER_CART]({  commit }, payload) {

      api[types.CHANGE_CHOOSE_OF_CUSTOMER_CART](payload)
        .then((res) => {
          if (res?.code == 1) {
            commit(types.GET_CART_INFO, res.data || { list: [] });
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // 购物袋加购-用户
    [types.ADD_TO_CUSTOMER_CART]({  commit }, payload) {

      api[types.ADD_TO_CUSTOMER_CART](payload)
        .then((res) => {
          if (res?.code == 1) {
            commit(types.GET_CART_INFO, res.data || { list: [] });
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // 购物袋删除-用户
    [types.DEL_CUSTOMER_CART]({  commit }, payload) {

      api[types.DEL_CUSTOMER_CART](payload)
        .then((res) => {
          if (res?.code == 1) {
            commit(types.GET_CART_INFO, res.data || { list: [] });
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // 购物袋修改(颜色&尺码&数量)-用户
    [types.UPDATE_CUSTOMER_ITEM_OPTIONS]({  commit }, payload) {

      api[types.UPDATE_CUSTOMER_ITEM_OPTIONS](payload)
        .then((res) => {
          if (res?.code == 1) {
            commit(types.GET_CART_INFO, res.data || { list: [] });
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // 购物袋合并-小程序用户
    // 返回 promise 供登录流程串行: 先合并完成, 再拉取用户购物袋
    [types.MERGE_CART]({  commit }, payload) {

      return api[types.MERGE_CART](payload)
        .then((res) => {
          if (res?.code == 1) {
            commit(types.GET_CART_INFO, res.data || { list: [] });
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // 获取购物袋-游客
    [types.GET_CART]({  commit }, payload) {

      api[types.GET_CART](payload)
        .then((res) => {
          if (res?.code == 1) {
            commit(types.GET_CART_INFO, res.data || { list: [] });
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // 购物袋加购-游客
    [types.ADD_TO_CART_GUEST]({  commit }, payload) {

      api[types.ADD_TO_CART_GUEST](payload)
        .then((res) => {
          if (res?.code == 1) {
            commit(types.GET_CART_INFO, res.data || { list: [] });
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // 购物袋选中/取消-游客
    // eslint-disable-next-line no-unused-vars
    [types.CHANGE_CHOOSE]({  commit }, payload) {

      api[types.CHANGE_CHOOSE](payload)
        .then((res) => {
          if (res?.code == 1) {
            commit(types.GET_CART_INFO, res.data || { list: [] });
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // 购物袋删除-游客
    [types.DEL_CART_GUEST]({  commit }, payload) {

      api[types.DEL_CART_GUEST](payload)
        .then((res) => {
          if (res?.code == 1) {
            commit(types.GET_CART_INFO, res.data || { list: [] });
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // 购物袋修改(颜色&尺码&数量)-游客
    [types.UPDATE_ITEM_OPTIONS]({  commit }, payload) {

      api[types.UPDATE_ITEM_OPTIONS](payload)
        .then((res) => {
          if (res?.code == 1) {
            commit(types.GET_CART_INFO, res.data || { list: [] });
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // eslint-disable-next-line no-unused-vars
    [types.GET_OSS_COMMON_CONFIG]({ state }) {
      api[types.GET_OSS_COMMON_CONFIG]()
        .then((res) => {
          state.commonConfig = res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    [types.GET_OSS_TAGS]({ state }) {
      api[types.GET_OSS_TAGS]()
        .then((res) => {
          const allTagsPage =
            ["Category", "Detail", "Search", "Cart", "Checkout", "Orderdetail", "history", "recommend", "home"]
          const showPage = res.data?.web?.show_page;
          const showPageArr = showPage === 'allPage'
            ? allTagsPage
            : (showPage || []);
          state.tagsConfig = { ...res.data?.web, show_page: showPageArr } || {};
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    changeCrmPoint({ state, commit }, payload) {
      if (state.userInfo) {
        let _userInfo = state.userInfo;
        _userInfo.crm = { ..._userInfo.crm, points: payload };
        commit(types.GET_PROFILE, _userInfo);
      }
    },
  },
});
